// Persists list pagination (currentPage*) per route across "back to list" navigation.
// Usage: mixins: [listPagePersistence(['currentPage', 'currentPageHO', ...])]
export default function listPagePersistence(pageKeys) {
  return {
    created() {
      const storageKey = `list-page:${this.$route.name}`

      let saved = {}
      try {
        saved = JSON.parse(sessionStorage.getItem(storageKey)) || {}
      } catch (e) {
        saved = {}
      }

      pageKeys.forEach(key => {
        if (typeof saved[key] === 'number' && saved[key] > 0 && key in this) {
          this[key] = saved[key]
        }
      })

      pageKeys.forEach(key => {
        this.$watch(key, value => {
          let current = {}
          try {
            current = JSON.parse(sessionStorage.getItem(storageKey)) || {}
          } catch (e) {
            current = {}
          }
          current[key] = value
          sessionStorage.setItem(storageKey, JSON.stringify(current))
        })
      })
    },
  }
}
